import ReactJoyride, { CallBackProps, Step, TooltipRenderProps } from "react-joyride";
import Button from "components/atoms/buttons/Button";
import { ArrowIconForWalkthrough } from "components/atoms/Icon";
import { useUserContext } from "components/context/UserContext";
import { useLoaderContext } from "components/context/LoaderContext";
import { useDeviceType, useLocalStorage, useRouter } from "components/hooks";
import WalkthroughThreeMagnets from "assets/Images/WalkthroughThreeMagnets.png";
import WalkthroughMagnet from "assets/Images/WalkthroughMagnetCard.png";
import { useEffect } from "react";
import { toast } from "react-toastify";
import useSideBarStore from "components/store/sidebarStore";
import { useWalkthroughContext } from "./WalkthroughContext";
import { LOCAL_STORAGE_KEYS, ROUTES, TOAST_CONFIG } from "../../../constants";

const steps: Step[] = [
  // Step 1
  {
    content: (
      <p className="w-80 font-satoshi text-xs font-semibold leading-7 text-white md:text-sm 2xl:w-96  2xl:text-lg">
        Welcome to MAGNETIQ! Get ready to start a journey of connection with your favorite brands and IP.
      </p>
    ),
    hideBackButton: true,
    showSkipButton: true,
    placement: "center",
    target: "body",
  },
  // Step 2
  {
    content: (
      <div className="w-96 max-w-[calc(85vw)] space-y-1 md:space-y-10 2xl:w-[480px]">
        <p className="font-satoshi text-xs font-semibold leading-7 text-white md:text-sm  2xl:text-lg">
          On MAGNETIQ, you can acquire Magnets, the digital representation of a membership card. Magnet holders will get
          a variety of benefits from the brands who issue them.
        </p>
        <img
          src={WalkthroughMagnet}
          alt="magnet-walkthrough"
          className=" mx-auto h-3/4 w-3/4 object-cover md:h-full md:w-full"
        />
      </div>
    ),
    placement: "center",
    showSkipButton: true,
    target: "body",
  },
  // Step 3
  {
    content: (
      <div className="w-[530px] max-w-[calc(85vw)] md:space-y-10 2xl:w-[620px]">
        <p className="font-satoshi text-xxs font-semibold leading-5 text-white md:text-sm md:leading-7  2xl:text-lg">
          Mementos represent the claimable benefits associated with a Magnet. Mementos have a variety of uses, and
          brands will communicate to you what you get for your Mementos!
        </p>
        <img
          src={WalkthroughThreeMagnets}
          alt="three-magnets-walkthrough"
          className=" mx-auto h-3/4 w-3/4 object-cover md:h-full md:w-full"
        />
      </div>
    ),
    showSkipButton: true,
    placement: "center",
    target: "body",
  },
  // Step 4
  {
    content: (
      <>
        <p className="w-80 font-satoshi text-xs font-semibold leading-7 text-white md:text-sm 2xl:w-96  2xl:text-lg">
          Your Magnets will sit on your user profile, what we affectionately call your Fridge. Mementos can be viewed
          when you click into your Magnets.
        </p>

        <ArrowIconForWalkthrough className="invisible absolute -bottom-20 left-20 h-24 w-24 rotate-[95deg] -scale-x-100 lg:visible" />
      </>
    ),

    placement: "top-start",
    styles: {
      spotlight: {
        borderRadius: "24px 24px 24px 24px",
      },
    },
    showSkipButton: true,
    target: ".user-fridge-container",
  },
  // Step 5
  {
    spotlightClicks: true,
    content: (
      <>
        <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
          Now, go explore the Discover Page to find new Magnets!
        </p>
        <ArrowIconForWalkthrough className="invisible absolute -left-28 bottom-10  h-24 w-24 md:visible" />
      </>
    ),
    placement: "right-end",
    styles: {
      spotlight: {
        borderRadius: "20px",
      },
      tooltipContainer: {
        marginTop: "120px",
      },
    },
    disableBeacon: true,
    showSkipButton: true,
    locale: { next: "DISCOVER" },
    target: ".discover-button",
  },
  // {
  //   spotlightClicks: true,
  //   content: (
  //     <>
  //       <p className="top-0 w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         The Discover Page is where you can find brands on the platform. Lets click into the MAGNETIQ profile.
  //       </p>
  //       <ArrowIconForWalkthrough className=" invisible absolute -left-28 -top-12 h-24 w-24 md:visible " />
  //     </>
  //   ),
  //   placement: "right-end",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //     tooltipContainer: {
  //       marginLeft: "450px",
  //       marginTop: "50px",
  //     },
  //   },
  //   showSkipButton: true,
  //   target: ".discover-brand-card",
  // },
  // {
  //   spotlightClicks: true,
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         On each brand page, you will see the full suite of their magnet offerings. Lets click into the MAGNETIQ Alpha
  //         Pass.
  //       </p>
  //       <ArrowIconForWalkthrough className="invisible absolute  -left-20 h-24  w-24 rotate-180 -scale-x-100 md:visible" />
  //     </>
  //   ),
  //   placement: "top",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //   },
  //   showSkipButton: true,

  //   target: ".magnet-public-profile-card",
  // },

  // {
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         Here on the Magnet page, we have basic information like price, supply and description.
  //       </p>
  //       <ArrowIconForWalkthrough className="invisible absolute -top-28 right-0 h-24 w-24 rotate-90 md:visible" />
  //     </>
  //   ),
  //   placement: "left-end",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //     tooltipContainer: {
  //       marginLeft: "40px",
  //     },
  //   },
  //   showSkipButton: true,
  //   offset: 40,
  //   target: ".magnet-info-container",
  // },
  // {
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         Here the brand will showcase in more detail the benefits you will accrue for acquiring the magnet and any
  //         other details.
  //       </p>
  //       <ArrowIconForWalkthrough className="invisible absolute -top-28 right-0 h-24 w-24 rotate-90 md:visible" />
  //     </>
  //   ),
  //   placement: "left-end",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //     tooltipContainer: {
  //       marginLeft: "40px",
  //     },
  //   },
  //   offset: 40,
  //   showSkipButton: true,
  //   target: ".magnet-benefits-grid",
  // },
  // {
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         Here is the Magnet activity, where you can see everything the brand has delivered upon in their program. We
  //         call this the accountability layer.
  //       </p>
  //       <ArrowIconForWalkthrough className="invisible absolute  -top-28 h-24 w-24 -rotate-90 -scale-x-100 md:visible" />
  //     </>
  //   ),
  //   placement: "right-end",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //   },
  //   offset: 40,
  //   showSkipButton: true,
  //   target: ".brand-activity-section",
  // },
  // {
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         So let’s get this thing!
  //         <br /> Click the <span className="text-accent">NEXT</span> button and we will get you your first Magnet!
  //       </p>
  //       <ArrowIconForWalkthrough
  //         className="invisible absolute
  //        left-24 -top-28 h-24 w-24 rotate-90 md:visible"
  //       />
  //     </>
  //   ),
  //   placement: "bottom-start",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "20px",
  //     },
  //     tooltipContainer: {
  //       marginTop: "100px",
  //       marginLeft: "-200px",
  //     },
  //   },
  //   disableBeacon: true,
  //   target: ".magnet-sale-container",
  // },
  // {
  //   content: (
  //     <>
  //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
  //         Now back on your profile, you have your first Magnet on your Fridge! Congratulations! Have a look around and
  //         explore the other things made possible by MAGNETIQ!
  //       </p>
  //       <ArrowIconForWalkthrough className="invisible absolute -top-28 h-24 w-24 -rotate-90 -scale-x-100 md:visible" />
  //     </>
  //   ),
  //   placement: "bottom-end",
  //   styles: {
  //     spotlight: {
  //       borderRadius: "12px",
  //     },
  //     tooltipContainer: {
  //       marginTop: "60px",
  //       marginLeft: "200px",
  //     },
  //   },
  //   disableBeacon: true,
  //   locale: { next: "FINISH TOUR" },
  //   target: ".fridge-button",
  // },
];

function PageTourModal({ step, primaryProps, tooltipProps, skipProps, backProps }: TooltipRenderProps) {
  const { loading } = useLoaderContext();

  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...tooltipProps}
      style={step.styles?.tooltipContainer}
      className="relative rounded-2xl border border-white bg-primary p-4 2xl:p-5"
    >
      {step.content}
      <div className="relative mt-6 flex justify-between space-x-3 md:space-x-2 2xl:mt-10 2xl:space-x-0">
        {step.showSkipButton && (
          <Button
            onClick={skipProps.onClick}
            variant="primary"
            text="Skip Tour"
            additionalClasses="xl:px-6 xl:py-2 xl:text-xs 2xl:text-sm 2xl:px-6 2xl:py-4 font-satoshi"
          />
        )}
        <div className="flex gap-2">
          {/* eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type */}
          {step.hideBackButton || (
            <Button
              onClick={backProps.onClick}
              disabled={loading}
              text={(step.locale?.back as string | undefined) || "BACK"}
              variant="primary"
              additionalClasses="xl:px-5 xl:py-2 xl:text-xs 2xl:text-sm 2xl:px-6 2xl:py-4 font-satoshi"
            />
          )}
          <Button
            onClick={primaryProps.onClick}
            disabled={loading}
            text={(step.locale?.next as string | undefined) || "NEXT"}
            variant="rustPinkSolid"
            additionalClasses="xl:px-5 xl:py-2 xl:text-xs 2xl:text-sm 2xl:px-6 2xl:py-4 font-satoshi"
          />
        </div>
      </div>
    </div>
  );
}

function Walkthrough() {
  const router = useRouter();
  const {
    walkthroughData,
    setCurrentWalkthroughStep,
    stepFromUrl,
    setWalkthroughRun,
    // handleNavigateToMagnetiqMagnetPublicProfile,
    // handleNavigateToMagnetiqBrandPublicProfile,
    endMagnetiqProgram: handleEndMagnetiqProgram,
  } = useWalkthroughContext();
  const { userDetails, isUserLoggedIn, reloadUserData } = useUserContext();

  const { isMobile } = useDeviceType();

  const { updateSideBarVisibility } = useSideBarStore();

  const [skipOnboardingFlag, , removeOnboardingKey] = useLocalStorage(LOCAL_STORAGE_KEYS.SKIP_ONBOARDING);

  useEffect(() => {
    // magnetiq_program_status
    // 0: initial
    // 1: account setup
    // 2: completed

    if (isUserLoggedIn && userDetails?.magnetiq_program_status === 1) {
      if (skipOnboardingFlag) {
        removeOnboardingKey();
        handleEndMagnetiqProgram(
          () => {},
          () => {},
        );
      }
    }
  }, [userDetails?.magnetiq_program_status]);

  const handleEndMagnetiqProgramErrors = (errorMessage: string) => {
    toast.error(errorMessage, TOAST_CONFIG);
    setWalkthroughRun(true);
  };

  const handleEndMagnetiqProgramSuccess = () => {
    updateSideBarVisibility(false);
    reloadUserData();
    // if (isMobile) {
    //   router.go("/?tab=Fridge");
    // } else {
    //   router.go("/");
    // }
  };

  const handleJoyrideCallback = async (data: CallBackProps) => {
    const { type, index, action } = data;

    if (type === "step:after" && action === "next") {
      switch (index) {
        // mobile only
        case 2:
          if (isMobile) {
            router.go(`${ROUTES.USER_PROFILE_PAGE}?tab=Fridge&onboarding-step=3`, {
              replace: true,
            });
          } else {
            setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
          }
          break;
        case 3:
          setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
          if (isMobile) {
            setWalkthroughRun(false);
            updateSideBarVisibility(true);
            setTimeout(() => {
              setWalkthroughRun(true);
              // This timeout is needed as joyride scrolls page a bit down.
              setTimeout(() => {
                window.scrollTo(0, 0);
              }, 300);
            }, 200);
          }
          break;
        case 4:
          setWalkthroughRun(false);
          handleEndMagnetiqProgram(() => {
            handleEndMagnetiqProgramSuccess();
            router.go("/discover");
          }, handleEndMagnetiqProgramErrors);
          // endMagnetiqProgram();
          // router.go("/discover?onboarding-step=5");
          // updateSideBarVisibility(false);
          break;
        // case 5:
        //   setWalkthroughRun(false);
        //   handleNavigateToMagnetiqBrandPublicProfile();
        //   break;
        // case 6:
        //   setWalkthroughRun(false);
        //   handleNavigateToMagnetiqMagnetPublicProfile();
        //   break;
        // case 7:
        //   if (isMobile) {
        //     setSearchParams({ ...searchParams, tab: "Details", "onboarding-step": "8" }, { replace: true });
        //   } else {
        //     setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
        //   }
        //   break;
        // case 8:
        //   if (isMobile) {
        //     setSearchParams({ ...searchParams, tab: "Activity", "onboarding-step": "9" }, { replace: true });
        //   } else {
        //     setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
        //   }
        //   break;
        // case 10:
        //   if (isMobile) {
        //     setWalkthroughRun(false);
        //     updateSideBarVisibility(true);
        //     setTimeout(() => {
        //       setWalkthroughRun(true);
        //       // This timeout is needed as joyride scrolls page a bit down.
        //       setTimeout(() => {
        //         window.scrollTo(0, 0);
        //       }, 400);
        //     }, 200);
        //   }
        //   setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
        //   break;
        // case 11:
        //   if (isMobile) {
        //     updateSideBarVisibility(false);
        //   }
        //   setWalkthroughData((prevState) => ({ ...prevState, run: false, tourActive: false }));
        //   endMagnetiqProgram();
        //   break;
        default:
          if (Number(stepFromUrl) + 1 < steps.length) {
            setCurrentWalkthroughStep(Number(stepFromUrl) + 1);
          } else {
            setWalkthroughRun(false);
          }
      }
    } else if (type === "step:after" && action === "prev") {
      switch (index) {
        case 4:
        case 3:
        case 2:
        case 1:
          setCurrentWalkthroughStep(Number(stepFromUrl) - 1);
          break;
        default:
      }
    } else if (action === "skip") {
      handleEndMagnetiqProgram(handleEndMagnetiqProgramSuccess, handleEndMagnetiqProgramErrors);
    }
  };

  const stepForDevice: Step[] = isMobile
    ? steps.map((step, idx) => {
        switch (idx) {
          case 3:
            return {
              ...step,
              placement: "left",
            };
          case 4:
            return {
              ...step,
              placement: "bottom",
              styles: { ...step.styles, tooltipContainer: { marginTop: "100px" } },
            };
          case 5:
            return {
              ...step,
              styles: {
                ...step.styles,
                placement: "top-end",
                tooltipContainer: { marginTop: "10px" },
              },
            };
          // case 6:
          //   return {
          //     ...step,
          //     placement: "bottom",
          //   };
          // case 7:
          //   return {
          //     ...step,
          //     placement: "bottom",
          //   };
          // case 9:
          //   return {
          //     content: (
          //       <p className="w-80 font-satoshi text-sm font-semibold leading-7 text-white 2xl:w-96  2xl:text-lg">
          //         Here is the Magnet activity, where you can see everything the brand has delivered upon in their
          //         program. We call this the accountability layer.
          //       </p>
          //     ),
          //     target: ".brand-activity-section",
          //     showSkipButton: true,
          //     styles: { tooltipContainer: { bottom: "300px" } },
          //   };
          // case 10:
          //   return {
          //     ...step,
          //     placement: "bottom",
          //     styles: {},
          //   };
          // case 11:
          //   return {
          //     ...step,
          //     placement: "bottom",
          //     styles: {},
          //   };
          default:
            return step;
        }
      })
    : steps;

  return (
    <>
      {walkthroughData.tourActive && !walkthroughData.run && (
        <div className="fixed top-0 z-10 h-screen w-screen bg-black bg-opacity-80" />
      )}
      <ReactJoyride
        callback={handleJoyrideCallback}
        continuous
        disableCloseOnEsc
        disableOverlayClose
        // disableScrolling
        // disableScrollParentFix
        scrollOffset={120}
        stepIndex={Number(stepFromUrl)}
        floaterProps={{
          hideArrow: true,
        }}
        run={walkthroughData.run}
        tooltipComponent={PageTourModal}
        styles={{
          overlay: {
            background: "white",
            opacity: "30%",
          },
          tooltipContainer: {
            textAlign: "left",
          },
        }}
        spotlightPadding={16}
        steps={stepForDevice}
      />
    </>
  );
}

export default Walkthrough;
